import { render, staticRenderFns } from "./hospitalManager.vue?vue&type=template&id=9e6ead94&scoped=true&"
import script from "./hospitalManager.vue?vue&type=script&lang=js&"
export * from "./hospitalManager.vue?vue&type=script&lang=js&"
import style0 from "./hospitalManager.vue?vue&type=style&index=0&id=9e6ead94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6ead94",
  null
  
)

export default component.exports